// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OperatingStatus_wrapper__3Lp9J","content":"OperatingStatus_content__3JJ_2"};